// removed by extract-text-webpack-plugin
module.exports = {"fa":"fa","fa-search":"fa-search","search-top":"search-top","vtd-search":"vtd-search","search-input":"search-input","btn-search":"btn-search"};


//////////////////
// WEBPACK FOOTER
// ./components/layouts/master/sub-header/_SearchBar.scss
// module id = ./components/layouts/master/sub-header/_SearchBar.scss
// module chunks = 0